<template>
  <div>
    <b-row class="mb-2">
      <b-col sm="4">
        <b-form-group label="Provincia:">
          <b-select
            :options="provincias"
            @input="getMunicipios"
            placeholder="Seleccione provincia ..."
            @blur="$v.domicilio.provincia.$touch"
            :state="$v.domicilio.provincia.$dirty ? !$v.domicilio.provincia.$error : null"
          />
        </b-form-group>
      </b-col>
      <b-col sm="5">
        <b-form-group label="Localidad:">
          <autocomplete
            :data="municipios"
            input-class="form-control"
            @selected="domicilio.localidad = $event.text"
            @blur="$v.domicilio.localidad.$touch"
            :state="$v.domicilio.localidad.$dirty ? !$v.domicilio.localidad.$error : null"
          />
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-group label="Código Postal:">
          <b-input
            type="text"
            placeholder="Ingrese CP"
            v-model="domicilio.cp"
            @blur="$v.domicilio.cp.$touch"
            :state="$v.domicilio.cp.$dirty ? !$v.domicilio.cp.$error : null"
          />
        </b-form-group>
      </b-col>
      <b-col sm="7">
        <b-form-group label="Calle:">
          <b-input
            type="text"
            placeholder="Ingrese calle"
            v-model="domicilio.calle"
            @blur="$v.domicilio.calle.$touch"
            :state="$v.domicilio.calle.$dirty ? !$v.domicilio.calle.$error : null"
          />
        </b-form-group>
      </b-col>
      <b-col sm="2">
        <b-form-group label="Número:">
          <b-input
            type="text"
            placeholder="Nro"
            v-model="domicilio.numero"
            @blur="$v.domicilio.numero.$touch"
            :state="$v.domicilio.numero.$dirty ? !$v.domicilio.numero.$error : null"
          />
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-group label="Piso / depto:">
          <b-input
            type="text"
            placeholder="Ingresar"
            v-model="domicilio.piso"
            @blur="$v.domicilio.piso.$touch"
            :state="$v.domicilio.piso.$dirty ? !$v.domicilio.piso.$error : null"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Autocomplete from '@/components/Autocomplete';
import { required } from 'vuelidate/lib/validators';

export default {
  props: {
    domicilio: {
      type: Object,
      required: true
    },
    provincias: {
      type: Array,
      required: true
    },
    touched: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Autocomplete
  },
  data() {
    return {
      municipios: []
    };
  },
  validations: {
    domicilio: {
      provincia: { required },
      localidad: { required },
      cp: { required },
      calle: { required },
      numero: { required },
      piso: { required }
    }
  },
  methods: {
    getMunicipios(cod_dpto) {
      this.domicilio.provincia = this.provincias.find(item => item.value == cod_dpto)['text'];
      this.domicilio.localidad = '';
      return this.$api('tablas/municipios/' + cod_dpto).then(res => {
        this.municipios = res.data.map(item => ({ text: item.localidad, value: item.cod_municipio }));
      });
    }
  },
  watch: {
    touched(val) {
      if (val) {
        this.$v.domicilio.$touch()
      } else {
        this.$v.$reset();
      }
    }
  }
};
</script>
